import myTrainingProgramTypes from './commit-types';
import oitModel from '../../models/oit';
import trainingPhaseModel from '../../models/training-phase';

const INITIAL_MY_TRAINING_PHASE_STATE = {
  oit: null,
  isLoading: false,
  trainingPhases: null,
};

function myTrainingProgramReducers(state = INITIAL_MY_TRAINING_PHASE_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case myTrainingProgramTypes.PUSH_MY_TRAINING_PROGRAM_TRAINING_PHASES:
      return {
        ...state,
        trainingPhases: [...action.trainingPhases.map(phase => trainingPhaseModel(phase))],
      };
    case myTrainingProgramTypes.SET_MY_TRAINING_PROGRAM_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case myTrainingProgramTypes.SET_MY_TRAINING_PROGRAM_OIT:
      return {
        ...state,
        oit: oitModel(action.oit),
      };
    default:
      return state;
  }
}

export default myTrainingProgramReducers;
